export const screenings = [
  {
    id: "scr-001",
    filmId: "interstellar-remaster",
    filmTitle: "星际穿越·穹顶重制版",
    date: "2026-10-13",
    time: "10:30",
    hall: "一号穹顶厅",
    price: 88,
    tech: "球幕激光 8K",
  },
  {
    id: "scr-002",
    filmId: "deep-sea-odyssey",
    filmTitle: "深海奇境",
    date: "2026-10-13",
    time: "13:00",
    hall: "二号穹顶厅",
    price: 68,
    tech: "球幕 3D",
  },
  {
    id: "scr-003",
    filmId: "planet-earth-dome",
    filmTitle: "地球脉动·穹顶版",
    date: "2026-10-13",
    time: "15:30",
    hall: "一号穹顶厅",
    price: 68,
    tech: "球幕 3D",
  },
  {
    id: "scr-004",
    filmId: "quantum-drift",
    filmTitle: "量子迷航",
    date: "2026-10-13",
    time: "19:00",
    hall: "三号穹顶厅",
    price: 98,
    tech: "球幕激光 8K",
  },
  {
    id: "scr-005",
    filmId: "interstellar-remaster",
    filmTitle: "星际穿越·穹顶重制版",
    date: "2026-10-14",
    time: "11:00",
    hall: "一号穹顶厅",
    price: 88,
    tech: "球幕激光 8K",
  },
  {
    id: "scr-006",
    filmId: "age-of-dinosaurs",
    filmTitle: "恐龙纪元",
    date: "2026-10-14",
    time: "14:00",
    hall: "二号穹顶厅",
    price: 78,
    tech: "球幕 3D",
  },
  {
    id: "scr-007",
    filmId: "edge-of-the-cosmos",
    filmTitle: "宇宙边缘",
    date: "2026-10-14",
    time: "20:00",
    hall: "三号穹顶厅",
    price: 98,
    tech: "球幕激光 8K",
  },
  {
    id: "scr-008",
    filmId: "aurora-journey",
    filmTitle: "极光之旅",
    date: "2026-10-15",
    time: "10:00",
    hall: "二号穹顶厅",
    price: 68,
    tech: "球幕 3D",
  },
  {
    id: "scr-009",
    filmId: "mars-dawn",
    filmTitle: "火星黎明",
    date: "2026-10-15",
    time: "16:00",
    hall: "一号穹顶厅",
    price: 88,
    tech: "球幕激光 8K",
  },
  {
    id: "scr-010",
    filmId: "city-of-time",
    filmTitle: "时光倒流的城市",
    date: "2026-10-15",
    time: "19:30",
    hall: "三号穹顶厅",
    price: 78,
    tech: "球幕 3D",
  },
  {
    id: "scr-011",
    filmId: "planet-earth-dome",
    filmTitle: "地球脉动·穹顶版",
    date: "2026-10-16",
    time: "13:30",
    hall: "一号穹顶厅",
    price: 68,
    tech: "球幕 3D",
  },
  {
    id: "scr-012",
    filmId: "promise-of-the-stars",
    filmTitle: "星海之约",
    date: "2026-10-16",
    time: "19:00",
    hall: "二号穹顶厅",
    price: 78,
    tech: "球幕 3D",
  },
  {
    id: "scr-013",
    filmId: "interstellar-remaster",
    filmTitle: "星际穿越·穹顶重制版",
    date: "2026-10-17",
    time: "10:30",
    hall: "一号穹顶厅",
    price: 88,
    tech: "球幕激光 8K",
  },
  {
    id: "scr-014",
    filmId: "age-of-exploration",
    filmTitle: "大航海时代",
    date: "2026-10-17",
    time: "14:30",
    hall: "三号穹顶厅",
    price: 68,
    tech: "球幕 3D",
  },
  {
    id: "scr-015",
    filmId: "quantum-drift",
    filmTitle: "量子迷航",
    date: "2026-10-17",
    time: "20:00",
    hall: "一号穹顶厅",
    price: 98,
    tech: "球幕激光 8K",
  },
  {
    id: "scr-016",
    filmId: "deep-sea-odyssey",
    filmTitle: "深海奇境",
    date: "2026-10-18",
    time: "11:00",
    hall: "二号穹顶厅",
    price: 68,
    tech: "球幕 3D",
  },
  {
    id: "scr-017",
    filmId: "city-in-the-clouds",
    filmTitle: "云端之城",
    date: "2026-10-18",
    time: "15:00",
    hall: "三号穹顶厅",
    price: 58,
    tech: "球幕 3D",
  },
  {
    id: "scr-018",
    filmId: "edge-of-the-cosmos",
    filmTitle: "宇宙边缘",
    date: "2026-10-18",
    time: "19:30",
    hall: "一号穹顶厅",
    price: 98,
    tech: "球幕激光 8K",
  },
  {
    id: "scr-019",
    filmId: "aurora-journey",
    filmTitle: "极光之旅",
    date: "2026-10-19",
    time: "10:30",
    hall: "二号穹顶厅",
    price: 68,
    tech: "球幕 3D",
  },
  {
    id: "scr-020",
    filmId: "mars-dawn",
    filmTitle: "火星黎明",
    date: "2026-10-19",
    time: "16:30",
    hall: "三号穹顶厅",
    price: 88,
    tech: "球幕激光 8K",
  },
];